import { render, staticRenderFns } from "./JobsearchRecruiteeSearchBox.vue?vue&type=template&id=164a744b&scoped=true&"
import script from "./JobsearchRecruiteeSearchBox.vue?vue&type=script&lang=ts&"
export * from "./JobsearchRecruiteeSearchBox.vue?vue&type=script&lang=ts&"
import style0 from "./JobsearchRecruiteeSearchBox.vue?vue&type=style&index=0&id=164a744b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a744b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
